import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { RatingSVGComponent } from '@valk-nx/components/ui-rating/src/lib/rating-svg/rating-svg';
import { cn } from '@valk-nx/core/lib/core';
import type { SocialProofInterface } from '@valk-nx/core/lib/interfaces/hotels.interface';

import type { IconVariantType, USPInterface } from './usp-bar.interface';

@Component({
	selector: 'vp-usp-bar',
	imports: [
		AngularSvgIconModule,
		CommonModule,
		RatingSVGComponent,
		TranslatePipe,
	],
	templateUrl: './usp-bar.component.html',
})
export class UspBarComponent {
	usps = input<USPInterface[] | undefined>();
	iconType = input<'' | 'solid' | 'shaded'>('');
	iconVariant = input<IconVariantType>('default');
	rating = input<SocialProofInterface | null>(null);
	emitClickEvents = input<boolean>(false);
	showUnionLine = input<boolean>(false);

	emitClick = output<USPInterface>();

	cn = cn;

	uspItems = computed<USPInterface[]>(() => {
		if (this.rating()?.score) {
			return this.usps()?.slice(0, 4) || [];
		}
		return this.usps() ?? [];
	});

	ratingKey = computed<string>(() => {
		const currentRating = this.rating();

		if (currentRating?.score) {
			const score = currentRating.score * 10;
			if (score >= 88) {
				return 'amazing';
			} else if (score >= 84) {
				return 'fantastic';
			}
		}
		return 'great';
	});

	iconVariantClass = computed<string>(() => {
		switch (this.iconVariant()) {
			case 'accent':
				return 'icon-container-accent';
			case 'success':
				return 'icon-container-success';
			case 'warning':
				return 'icon-container-warning';
			case 'error':
				return 'icon-container-error';
			case 'info':
				return 'icon-container-info';
			default:
				return 'default';
		}
	});

	iconTypeClass = computed<string>(() => {
		switch (this.iconType()) {
			case 'shaded':
				return 'icon-container-shaded';
			case 'solid':
				return 'icon-container-solid';
			default:
				return '';
		}
	});

	onClick(event: Event, usp: USPInterface) {
		if (this.emitClickEvents() && !usp.disabled) {
			event.preventDefault();
			this.emitClick.emit(usp);
		}
	}
}
